module.exports = __webpack_public_path__ + "img/t4-13.90a866e1.svg";